import { render, staticRenderFns } from "./ForecastAnalysis.vue?vue&type=template&id=3c120051&scoped=true&"
import script from "./ForecastAnalysis.vue?vue&type=script&lang=js&"
export * from "./ForecastAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./ForecastAnalysis.vue?vue&type=style&index=0&id=3c120051&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c120051",
  null
  
)

export default component.exports